"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InputFieldComponent = void 0;

var _stylitas = require("@creditas/stylitas");

var _baseComponent = require("./baseComponent.style");

const InputFieldComponent = _stylitas.styled.input`
  ${_baseComponent.inputBase};
  ${_baseComponent.inputWithIcon};
  ${_baseComponent.inputColorHover};
  &:hover {
    ${_baseComponent.inputColorHover};
  }
  ${_baseComponent.inputColorFocused};
  &:focus {
    ${_baseComponent.inputColorFocused};
  }
  ${_baseComponent.inputColorDisabled};
  ${_baseComponent.inputColorReadOnly};
`;
exports.InputFieldComponent = InputFieldComponent;